module.exports = __webpack_public_path__ + "static/image-small-6fafb30fa919d7bb53cc66389a2afcea.jpg";